/// <reference path="../../../../../typings/index.d.ts" />
module Meevo.Plugins.RatingsControlPanel {

    import IRatingControlPanelCriteria = Meevo.Plugins.RatingsControlPanel.IRatingControlPanelCriteria;

    export class RatingControlPanelCriteriaModel implements IRatingControlPanelCriteriaModel {
        public rating: number;
        public startDate: Date;
        public endDate: Date;

        public pageNumber: number;
        public itemsPerPage: number;

        public employee: Meevo.Model.Employee;
        public client: Meevo.Model.ClientListItem;
        public serviceCategory: Meevo.Model.ServiceCategory;
        public service: any;
        public displayType: DisplayRatingTypesEnum;
        public includeDeleted;
        public showActiveEmployee: boolean;
        public showInactiveEmployee: boolean;

        public get employeeId(): string {
            return this.employee ? this.employee.id : null;
        }

        public get employeeIds(): string[] {
            return this.employee ? [this.employee.id] : null;
        }

        public get clientId(): string {
            return this.client ? this.client.id : null;
        }

        public get serviceCategoryId(): string {
            return this.serviceCategory ? this.serviceCategory.id : null;
        }

        public get serviceId(): string {
            return this.service ? this.service.id : null;
        }

        public get serviceIds(): string[] {
            return this.service ? [this.service.id] : null;
        }

        public get isHidden(): boolean {
            if (this.displayType === DisplayRatingTypesEnum.Published) {
                return false;
            }

            if (this.displayType === DisplayRatingTypesEnum.Unpublished) {
                return true;
            }

            return null;
        }

        public get isDeleted(): boolean {
            if (this.displayType === DisplayRatingTypesEnum.Deleted) {
                return true;
            }

            if (this.includeDeleted) {
                return null;
            }

            return false;
        }


        constructor(params: IRatingControlPanelCriteria = <IRatingControlPanelCriteria>{}) {
            _.assign(this, params);
        }

        public getCriteria(withClient: boolean = true): IRatingsListRequest {
            return {
                criteria: {
                    employeeIds: this.employeeIds,
                    clientId: withClient ? this.clientId : null,
                    serviceCategoryId: this.serviceCategoryId,
                    serviceIds: this.serviceIds,
                    rating: withClient ? this.rating : null,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    isHidden: withClient ? this.isHidden : null,
                    isDeleted: withClient ? this.isDeleted : false,
                    showActiveEmployee: this.employeeId ? null : this.showActiveEmployee,
                    showInactiveEmployee: this.employeeId ? null :  this.showInactiveEmployee,
                },
                pageNumber: this.pageNumber,
                itemsPerPage: this.itemsPerPage,
            };
        }

    }
}
